module.exports = __webpack_public_path__ + "img/notes-ar.825c0f13.png";